import { createFileRoute } from "@tanstack/react-router";
import { PeopleIcon } from "../../components/icons/sidebar-icons";
import { ModulePlaceholder } from "../../components/modules/module-placeholder";

export const Route = createFileRoute("/_app/volunteers/records")({
	component: () => <ModulePlaceholder messageKey="volunteerRecords.message" icon={PeopleIcon} />,
});
